import React from "react";
 import {DynamicImagesUrl} from './GetDynamicImages.js';



//import homeIcon from '../assets/images/frontend/icons/home.svg';
// import challengeIcon from '../assets/images/frontend/icons/challenge.svg';
// import searchIcon from '../assets/images/frontend/icons/search.svg';
// import liveStreamIcon from '../assets/images/frontend/icons/live-stream.svg';
// import preferenceIcon from '../assets/images/frontend/icons/preference.svg';


// import HeadBg from '../assets/images/frontend/home-head-bg.png';
// import MidBg from '../assets/images/frontend/home-mid-bg.png';
// import FootBg from '../assets/images/frontend/home-footer-bg.png';

// import NewMidBg from '../assets/images/frontend/home-new-mid-bg.png';

 


const GetImage=async(imagepath)=>{

 return DynamicImagesUrl + imagepath;

}


const homeIcon=await GetImage('icons/home.svg')
const challengeIcon=await GetImage('icons/challenge.svg')
const challengewinnerIcon=await GetImage('icons/challenge-winner.png')

const searchIcon=await GetImage('icons/search.svg')
const liveStreamIcon=await GetImage('icons/live-stream.svg')
const preferenceIcon=await GetImage('icons/preference.svg')


const streamingIcon=await GetImage('icons/streaming.png')
const userIcon=await GetImage('icons/user.svg')
const signOutIcon=await GetImage('icons/sign-out.png')
const messageIcon=await GetImage('icons/message.png')
const referralIcon=await GetImage('icons/invite-friends.png')
const angleLeft=await GetImage('icons/angle-left.png')
const calendarIcon=await GetImage('icons/calendar.svg')
const clockIcon=await GetImage('icons/clock.svg')
//const addReelIcon=await GetImage('icons/add-reel.svg')
const addReelIcon=await GetImage('icons/add-reel.png')

const filterIcon=await GetImage('icons/filter.png')
const logOutIcon=await GetImage('icons/log-out.png')






 
const HeadBg=await GetImage('home-head-bg.png')
const MidBg=await GetImage('home-mid-bg.png')
const FootBg=await GetImage('home-footer-bg.png')
const NewMidBg=await GetImage('home-new-mid-bg.png')


const SiteLogo=await GetImage('logo.png')
const SiteLogoDark=await GetImage('logo-dark.png')
const SiteFavicon=await GetImage('favicon.png')

const FstLogo=await GetImage('fst-logo.png')


const Banner=await GetImage('banner.png')
const Vision=await GetImage('vision.png')


const Whybg=await GetImage('why-bg.png')



const Whyfirst=await GetImage('why-1.png')

const Whysecond=await GetImage('why-2.png')
const Whythird=await GetImage('why-3.png')
const Whyfour=await GetImage('why-4.png')
const Whyfive=await GetImage('why-5.png')
const Whysix=await GetImage('why-6.png')

const Servicefirst=await GetImage('service-1.png')


const Servicesecond=await GetImage('service-2.png')
const Servicethird=await GetImage('service-3.png')
const Servicefour=await GetImage('service-4.png')
const Servicefive=await GetImage('service-5.png')
const Servicesix=await GetImage('service-6.png')


const Visionfirst=await GetImage('vision-1.png')

const Visionsecond=await GetImage('vision-2.png')
const Visionthird=await GetImage('vision-3.png')
const Visionfour=await GetImage('vision-4.png')

const blogBg=await GetImage('blog/blog-banner.jpg')
const blogImage=await GetImage('blog/top-10-social-networking-apps-for-kids-in-mumbai.jpg')

 
export {blogImage, blogBg,Whybg,Visionfirst,Visionsecond,Visionthird,Visionfour,  Servicefirst,Servicesecond,Servicethird,Servicefour,Servicefive,Servicesix,Whyfirst,Whysecond,Whythird,Whyfour,Whyfive,Whysix,Vision,Banner,FstLogo,logOutIcon,SiteLogo,SiteLogoDark ,SiteFavicon, filterIcon,addReelIcon,HeadBg,MidBg,FootBg,NewMidBg,homeIcon,challengeIcon,challengewinnerIcon,searchIcon,liveStreamIcon,preferenceIcon,streamingIcon,userIcon,signOutIcon,messageIcon,referralIcon ,angleLeft ,calendarIcon,clockIcon}